module.exports = __webpack_public_path__ + "img/icon_pdf_light.fe22528f.svg";